export default __webpack_public_path__ + "/dist/images/store-icon.709bbf5f73f0504f4bdee9c414734d3d.svg";